/* eslint-disable */
import {
  ClickAwayListener,
  Divider,
  MenuList,
  Paper,
  Popper,
  RootRef, useMediaQuery, useTheme,
} from '@material-ui/core'
import { debounce } from 'lodash'
import React, { useState } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import {
  FiHome,
  FiMoreVertical,
  FiPlusSquare,
  FiPrinter,
  FiX,
} from 'react-icons/fi'
import {
  Button,
  ToolbarMobileItem,
} from '../../../../components/Calendar/BookingCalendar/Toolbar'
import { theme } from '../../../../theme'
import { isFirefox } from '../../../../components/DetectBrowser/DetectBrowser'
import { useGoToPremium } from '../../../../hooks/useGoToPremium'
import { IToolbarProps } from './Toolbar'
import ToolbarMobileContainer from './ToolbarMobileContainer'
import useIsScope from '../../../../hooks/useIsScope'
import { PermissionScope } from '../../../Employees'
import { useSelector } from 'react-redux'
import { getUserSummary } from '../../../../reducers/userObject/selectors/settings'
import { isLicenseValid } from '../../../../reducers/userAccount/selectors/license'
import UpgradePremiumBlockScreenModal from '../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function ToolbarMobile({
  toggleSummary,
  openAddRoomModal,
  isPremium,
  summary,
  t,
  openPrintModal,
  openAddReservationModal,
}: IToolbarMobileDispatch & WithTranslation & IToolbarProps) {
  const [expanded, toggleExpanded] = React.useState(false)
  const theme2 = useTheme()
  const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)
  const anchorEl = React.useRef()
  const [goToPremiumUri, _] = useGoToPremium()
  const scope = useIsScope({
    room: [PermissionScope.SCOPE_CAN_EDIT_ROOMS],
    reservation: [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS],
  })

  const summarySettings = useSelector(getUserSummary)
  const isUserLicenceValid = useSelector(isLicenseValid)

  function toggleMenu() {
    debounce(function() {
      toggleExpanded(!expanded)
    }, 100)()
  }

  function mobileAddReservationClick() {
    setIsModalOpened(true)
  }

  function closeMenuOnClick() {
    if (isPremium && isUserLicenceValid) {
      openPrintModal()
    } else if (!isUserLicenceValid && isMobile) {
      setIsModalOpened(true)
    } else {
      goToPremiumUri()
    }
    toggleExpanded(false)
  }

  return (
    <ToolbarMobileContainer summary={summary}>
      <RootRef rootRef={anchorEl}>
        <Button
          className={'calendar-button-toolbar-toggle'}
          onClick={toggleMenu}
          isExpanded={Boolean(expanded)}
        >
          {expanded ? <FiX size={26} /> : <FiMoreVertical size={26} />}
        </Button>
      </RootRef>

      <Popper
        open={expanded}
        anchorEl={anchorEl.current}
        placement={'bottom-end'}
        style={{ zIndex: 1299 }}
        modifiers={{
          arrow: {
            enabled: true,
          },
        }}
      >
        <ClickAwayListener onClickAway={toggleMenu}>
          <div>
            <div
              style={{
                borderColor: 'white transparent transparent transparent',
                borderStyle: 'solid',
                borderWidth: '10px 10px 0 10px',
                bottom: '0',
                height: '0',
                marginBottom: '-10px',
                marginTop: '0px',
                position: 'absolute',
                width: '0',
              }}
              x-arrow=""
            />
            <Paper>
              <MenuList>
                {scope.reservation && (
                  <ToolbarMobileItem
                    disabled={!isUserLicenceValid}
                    onClick={!isUserLicenceValid && isMobile ? mobileAddReservationClick : openAddReservationModal}
                    icon={<FiPlusSquare />}
                    text={t('add_reservation')}
                    color={!isUserLicenceValid ? theme.colors.palette.warmGreytThree : theme.colors.primary}
                    className={'calendar-button-toolbar-add_reservation'}
                    data-cy={'add-reservation-calendar-button'}
                  />
                )}
                {scope.room && (
                  <ToolbarMobileItem
                    onClick={openAddRoomModal}
                    icon={<FiHome />}
                    text={t('add_room')}
                    className={'calendar-button-toolbar-add_room'}
                    data-cy={'add-room-calendar-button'}
                  />
                )}
                {(scope.room || scope.reservation) && (
                  <Divider
                    style={{
                      margin: '5px 0px',
                    }}
                  />
                )}
                {Object.values(summarySettings).some(Boolean) && (
                  <ToolbarMobileItem
                    switchable={true}
                    onClick={toggleSummary}
                    checked={summary}
                    text={t('summary')}
                    className={'calendar-button-toolbar-summary'}
                  />
                )}
                {!isFirefox() && (
                  <ToolbarMobileItem
                    disabled={!isUserLicenceValid}
                    icon={<FiPrinter />}
                    text={t('print')}
                    className={'calendar-button-toolbar-print'}
                    onClick={closeMenuOnClick}
                  />
                )}
              </MenuList>
            </Paper>
          </div>
        </ClickAwayListener>
      </Popper>
      {isMobile && <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />}
    </ToolbarMobileContainer>
  )
}

export default withTranslation()(ToolbarMobile)

export interface IToolbarMobileDispatch {
  toggleSummary?: () => void
  openAddRoomModal: () => void
  openAddReservationModal: () => void
  openPrintModal?: () => void
}
